import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "parking-data" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "parking-data__zone" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "parking-data__description",
      innerHTML: _ctx.descriptionTop
    }, null, 8, _hoisted_2),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.zoneId), 1),
    _createElementVNode("div", {
      class: "parking-data__description",
      innerHTML: _ctx.zoneDesc
    }, null, 8, _hoisted_4)
  ]))
}